<template>
  <router-view />
  <a-modal
    v-model:open="announcementVisible"
    :title="announcementTitle"
    :closable="false"
    :maskClosable="false"
    width="1360px"
    class="announcement-modal"
  >
    <div style="max-height: 70vh; overflow-y: auto; font-size: 26px; line-height: 1.8; white-space: pre-wrap;">{{ announcementContent }}</div>
    <template #footer>
      <a-button type="primary" @click="handleConfirm">确认</a-button>
    </template>
  </a-modal>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { getGongGao } from '@/api/api'

const route = useRoute()
const announcementVisible = ref(false)
const announcementTitle = ref('公告')
const announcementContent = ref('')

watch(() => route.path, async (newPath, oldPath) => {
  if (oldPath === '/login' && newPath !== '/login') {
    try {
      const res = await getGongGao()
      if (res.code === 200 && res.data) {
        announcementTitle.value = res.data.title || '公告'
        announcementContent.value = res.data.neirong || ''
        announcementVisible.value = true
      }
    } catch (e) {
      console.error('获取公告失败:', e)
    }
  }
})

const handleConfirm = () => {
  announcementVisible.value = false
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100%;
}

.announcement-modal .ant-modal-body {
  padding: 24px 32px;
}
</style>
